import { fetchAllTransactions } from "@/services/lukita/transactions";

export default async function projectOverviewLoader({ params }) {
  const transactions = fetchAllTransactions({
    slug: params.projectSlug,
  });

  return { transactions };
}
